export default "https://cdn-static.gokick.com/assets/42f530e1bfe0c3dccbac116cd4d83f20c9a8b744/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";